//import { createApp } from "vue";
import Vue from 'vue'
import App from "./App.vue";
import router from "./router";
//import store from "./store";
import "./assets/css/font-awesome.min.css";
import "./assets/css/animate.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/index.scss";
import carousel from "v-owl-carousel";
import VueProgressBar from "vue-progressbar";
// import "swiper/dist/css/swiper.css";

// import SwiperClass, { /* swiper modules... */ } from 'Swiper'
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueSlickCarousel from "vue-slick-carousel";
import VueYoutube from 'vue-youtube'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueYoutube)
import VueHZoom from 'vue-h-zoom';
// import swiper module styles
// import "swiper/css";
// more module style...

// use swiper modules
// SwiperClass.use([/* swiper modules... */])

// import 'vue-video-player/src/custom-theme.css'



const options = {
  color: "#FFFFFF",
  failedColor: "#874b4b",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};
Vue.use(VueAwesomeSwiper)
Vue.use(VueSlickCarousel)
new Vue({
  router,
  //store,
  render: h => h(App)
}).$mount('#app')
// createApp(App)
//   .use(store)
//   .use(router)
//   .use(VueSlickCarousel)
//   .use(VueAwesomeSwiper)
//   .use(VueHZoom)
//   .use(VueVideoPlayer)

//   .mount("#app");

//   .use(VueProgressBar, options)
